import { ReactNode } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as LabelPrimitive from '@radix-ui/react-label';
import Fieldset from '@components/Form/Fieldset';
import clsx from 'clsx';

type RadioButtonItemData = {
  label: ReactNode;
  value: string;
};

type Props = {
  id: string;
  items: RadioButtonItemData[];
  label: string;
  row?: boolean;
  name?: string;
  required?: boolean;
  error?: string;
  defaultValue?: string;
};

function RadioGroup(props: Props) {
  const { id, items, name, label, row, required, error, defaultValue } = props;

  return (
    <Fieldset className={clsx('radio-group', { 'radio-group--row': row })} legend={label} asLabel>
      <RadioGroupPrimitive.Root
        className='radio-group__root'
        name={name ?? id}
        required={required}
        defaultValue={defaultValue}
      >
        {items.map((item, index) => (
          <div className='radio-group__item-container' key={`${id}-${index}`}>
            <RadioGroupPrimitive.Item
              className='radio-group__item'
              value={item.value}
              id={`${id}-${index}`}
              required={required}
            >
              <RadioGroupPrimitive.Indicator className='radio-group__indicator' />
            </RadioGroupPrimitive.Item>
            <LabelPrimitive.Root className='radio-group__label' htmlFor={`${id}-${index}`} asChild>
              <label>{item.label}</label>
            </LabelPrimitive.Root>
          </div>
        ))}
      </RadioGroupPrimitive.Root>
      {error ? <p>{error}</p> : null}
    </Fieldset>
  );
}

export default RadioGroup;
